import React from 'react';
import { bool, func, string } from 'prop-types';
import { Translate } from '@material-ui/icons';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: { SEE_TRANSLATION, SEE_ORIGINAL }
} = StringConstantsMixin;

const TranslateToggle = ({ isTranslated, handleOnClick, className }) => {
  const translateText = isTranslated ? SEE_ORIGINAL : SEE_TRANSLATION;

  return (
    <button className={`${styles.container} ${className}`} type="button" onClick={handleOnClick}>
      <Translate className={styles.translateIcon} />
      <div className={styles.translatedText}>{translateText}</div>
    </button>
  );
};

TranslateToggle.propTypes = {
  isTranslated: bool,
  handleOnClick: func.isRequired,
  className: string
};

TranslateToggle.defaultProps = {
  isTranslated: false,
  className: ''
};

export default TranslateToggle;
